<template>
	<div class="fuwu">
		<header-view></header-view>
		<div class="top">Flority Terms of Use</div>
		<div class="content">Last updated November 5, 2026</div>
		<div class="title">1. Who we are</div>
		<div class="content">FLORITY is a digital flower-arrangement app provided by HEARD (HK) LIMITED, Unit 1, 9/F, Wo Hing
		Commercial Building, 11 Wing Wo Street, Central, Hong Kong. Contact: jm@heard.ly.</div>
		<div class="title">2. Using FLORITY</div>
		<div class="content">You can arrange flowers, choose vases, save works on your device and export personalized images without
		creating an account. The app’s core features work offline and it does not provide an account, cloud
		backup or a FLORITY server for your works. Use the app lawfully and respect other people’s rights. If you
		are under the legal age to agree to these terms, a parent or guardian must agree for you.</div>
		<div class="title">3. Your creations and our assets</div>
		<div class="content">You retain rights in the original content you add. You may save and share finished arrangements for
		personal use. The app and its flower, vase and design assets remain owned by us or our licensors; do not
		resell or redistribute those assets as standalone files. Apple’s Standard EULA governs your App Store app
		license.</div>
		<div class="title">4. Local works and saved images</div>
		<div class="content">Drafts and Gallery works are stored locally; FLORITY does not provide cloud backup. Removing the app or
		clearing browser/site data can remove them, so export anything you want to keep.<br><br>You can generate
		a card with optional recipient, sender and note fields, then save the resulting image to your Photos
		library or, in the browser preview, download it. Those typed fields are used to draw the image, are not
		uploaded and are not written to persistent storage; the finished image contains whatever you entered.
		FLORITY does not post to social networks or send images to a FLORITY server. Anything you do with a saved
		image outside the app is governed by the destination service’s terms.</div>
		<div class="title">5. Device permissions</div>
		<div class="content">Saving an image asks iOS for permission to write the generated image to your Photos library. You may
		decline or change that permission in iOS Settings; arranging flowers and browsing the catalogue still
		work, but Save Image will not. FLORITY does not open, read, scan or upload your existing photo library,
		and does not use your camera, contacts or location.</div>
		<div class="title">6. Availability and updates</div>
		<div class="content">We maintain and improve FLORITY, but cannot promise uninterrupted availability or recovery of lost local
		works. Features may change with updates. These terms do not exclude liability or rights that cannot
		lawfully be excluded. We will identify changes by updating the date and give additional notice where
		required.</div>
		<div class="title">Useful links</div>
		<div class="content">
			<li><a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank" rel="noopener">Apple Standard EULA</a></li>
		</div>
		<div class="title">Contact</div>
		<div class="content">HEARD (HK) LIMITED<br>jm@heard.ly</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {},
		mounted() {

		}
	}
</script>

<style lang="less" scoped>
	.fuwu {
		padding: 87px 15px 40px;

		.top {
			font-size: 28px;
			font-weight: 600;
			padding: 25px 0;
		}

		.title {
			font-size: 20px;
			margin: 20px 0;
		}

		.content {
			font-size: 13px;

			li {
				margin: 10px 0;
			}

			a {
				color: inherit;
				text-decoration: underline;
			}
		}
	}
</style>
